import type { Router } from 'vue-router';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * GA4, only when VITE_GA4_ID is set. The previous build loaded Universal Analytics
 * (UA-2917298-1), which Google stopped processing in 2023.
 */
export function installAnalytics(router: Router): void {
  const id = import.meta.env.VITE_GA4_ID?.trim();
  if (!id) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js expects the arguments object itself, not an array.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // SPA: send page views from the router instead of on load only.
  window.gtag('config', id, { send_page_view: false });

  router.afterEach((to) => {
    window.gtag?.('event', 'page_view', {
      page_location: window.location.origin + router.resolve(to).href,
      page_title: document.title,
    });
  });
}
